import { useState } from "react";
import { useDispatch } from "react-redux";
import {useAppSelector} from "hooks/useAppSelector";
import { setHideZeroBalance, setIsFiat } from "app/store/slices/setting";
import { TKey } from "app/types/common";

export const usePreferencePanelData = () => {
    const isFiat = useAppSelector((state) => state.setting.isFiat);
    const hideZeroBalance = useAppSelector((state) => state.setting.hideZeroBalance);
    const dispatch = useDispatch();


    const [fiatCurrency, setFiatCurrency] = useState<TKey[]>(["1"]);
    const [odd, setOdd] = useState<TKey[]>(["1"]);
    const [privateMode, setPrivateMode] = useState(false);
    const [emailMarketing, setEmailMarketing] = useState(true);

    const onFiatChange = (v: boolean) => {
        dispatch(setIsFiat(v));
    };

    const onCurrencyChange = (v: TKey[]) => {
        setFiatCurrency(v);
    };

    const onOddChange = (v: TKey[]) => {
        setOdd(v);
    };

    const onPrivateModeChange = (v: boolean) => {
        setPrivateMode(v);
    };

    const onEmailMarketingChange = (v: boolean) => {
        setEmailMarketing(v);
    };

    const onHideZeroBalanceChange = (v: boolean) => {
        dispatch(setHideZeroBalance(v));
    };

    return {
        isFiat,
        hideZeroBalance,
        onHideZeroBalanceChange,
        fiatCurrency,
        onFiatChange,
        odd,
        onOddChange,
        onCurrencyChange,
        privateMode,
        onPrivateModeChange,
        emailMarketing,
        onEmailMarketingChange
    }
}